module.exports = __webpack_public_path__ + "media/images/logos/courtsdesk-text-white-119x41-c5a13c4d39c1ab09299a99b60c0924a6.svg";